module.exports = __webpack_public_path__ + "img/e9afafc7ab636a37dc16cad750e3fec3.png";